import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-[#f5f0e6] border-y border-[#e2e8f0]" data-id="element-115">
      <div className="container mx-auto px-4 text-center" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-2xl border border-[#e2e8f0]" data-id="element-117">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#fdfbf7] text-[#1a3622] mb-6 border border-[#d4af37]" data-id="element-118">
            <ShieldCheck className="w-10 h-10" data-id="element-119" />
          </div>

          <h2 className="text-3xl font-extrabold text-[#1a3622] mb-4" data-id="element-120">
            🛡️ GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <p className="text-lg text-[#4a3b32] mb-6 font-bold" data-id="element-121">
            Tu inversión está 100% protegida.
          </p>

          <p className="text-[#5c4033] mb-6" data-id="element-122">
            Abrí los 3 tomos. Revisá los 12 libros. Usá el módulo de producción
            bovina en tu clase más difícil esta semana.
          </p>

          <div className="bg-[#1a3622]/5 text-[#1a3622] font-bold text-lg py-4 px-6 rounded-xl mb-6 border border-[#1a3622]/10" data-id="element-123">
            Si sentís que tus alumnos no respondieron mejor, o que el material
            no te ahorró horas: te devolvemos el 100% de tu dinero. Sin
            preguntas, sin formularios, sin complicaciones.
          </div>
        </motion.div>
      </div>
    </section>;
}